<template>
    <main role="main">
        <article v-show="!pending" class="layout-contents-container" :data-details="isReplica ? true : null">
            <div class="layout-page-title">
                <button type="button" class="buttons-icon" data-type="line" data-icon="back" @click="goBack()">Back</button>
                <h1 class="page-title">
                    <template v-if="!isReplica">
                        {{$t('MENU.POLICY_TEMPLATE')}}<!--Policy Template-->
                    </template>
                    <template v-else>
                        {{$t('POLICY.LABEL.COPY_POLICY')}}<!--정책 복사-->
                    </template>
                </h1>
            </div>
            <!-- SUB TITLE -->

            <!-- Policy 복사일 때 -->
            <div v-if="isReplica" class="layout-contents">

                <fieldset class="forms">
                    <legend>{{ $t('POLICY.LABEL.POLICY_COPY_FORM')}}</legend>
                    <table class="tbl-forms">
                        <caption></caption>
                        <tbody>
                        <tr>
                            <td colspan="2">{{ $t('POLICY.LABEL.COPY_POLICY_DESC')}}<!--정책을 복사하여 사용자 환경에 맞게 설정된 내용을 수정할 수 있습니다.--> </td>
                        </tr>
                        <tr>
                            <th>
                                <label>{{ $t('LABEL.POLICY_NAME')}}<!--정책 이름--><span class="icon-required">{{$t('COMMON.FIELD_REQUIRE')}}</span></label>
                            </th>
                            <td>
                                <input type="text" class="text-field" maxlength="100" placeholder="이름을 입력하세요." :data-invalid="invalidPolicyTitle || duplicatedPolicyTitle ? true : null" style="width: 400px;" v-model="plcy.transTitl" @input="plcy.titl = $event.target.value; isInvalidPolicyTitle();">
                                <p class="invalid-message" v-if="invalidPolicyTitle">{{ $t('POLICY.INVALID.TITLE')}}<!--정책 이름을 입력해주세요.--></p>
                                <p class="invalid-message" v-if="duplicatedPolicyTitle">{{ $t('POLICY.INVALID.DUPLICATE')}}<!--이미 사용 중인 이름입니다.--></p>
                            </td>
                        </tr>
                        <tr>
                            <th>
                                <label>{{ $t('LABEL.DESCRIPTION')}}<!--설명--></label>
                            </th>
                            <td>
                                <input type="text" class="text-field" placeholder="" style="width: 800px;" v-model="plcy.desc">
                            </td>
                        </tr>
                        </tbody>
                    </table>
                    <!-- 적용된 규칙 -->
                    <SystemRuleList
                        :isReplica="isReplica"
                        :doRefresh="doRefresh"
                        :categoryList="categoryList"
                        :policy="plcy"
                        :cur-rule="detailRuleInfo"
                        :callOpenRuleDetail="openRuleDetail"
                        :callOpenPopup="openPopup"
                        :callDeleteRule="deleteGovernanceRule"
                        :key="getLocale"
                        :ruleList="govRuleListByKey"
                        :callSetSearchKey="setSearchKey"
                        :callSetSortColumn="setSortColumn"
                    />
                    <div class="forms-submit">
                        <button type="button" class="buttons" data-size="l" @click="goBack()">{{ $t('COMMON.BUTTON.CAMEL.CANCEL')}}<!--취소--></button>
                        <button type="button" class="buttons" data-type="key" data-size="l" @click="insertReplicaPolicy()">{{ $t('COMMON.BUTTON.UPPER.OK')}}<!--확인--></button>
                    </div>
                </fieldset>

            </div>
            <div v-else class="layout-contents" data-not-covered>
                <div class="left-view">

                    <!-- 기본 정보 -->
                    <div class="box-container" data-size-to-fit>
                        <table class="tbl-basic-info">
                            <caption>{{ $t('POLICY.LABEL.BASIC_INFORMATION')}}</caption>
                            <tbody>
                            <tr>
                                <th scope="row" style="width: 10%;">
                                    Title (EN) <!--생성-->
                                </th>
                                <td>
                                    <input v-model="plcy.enTitle" class="lang-input" placeholder="Title (EN) ">
                                </td>
                            </tr>
                            <tr>
                                <th scope="row" style="width: 10%;">
                                    Title (KO)<!--생성-->
                                </th>
                                <td>
                                    <input v-model="plcy.koTitle" class="lang-input" type="text" placeholder="Title (KO)">
                                </td>
                            </tr>
                            <tr>
                                <th scope="row" style="width: 10%;">
                                    Title (ZH) <!--생성-->
                                </th>
                                <td>
                                    <input v-model="plcy.zhTitle" class="lang-input" type="text" placeholder="Title (ZH)">
                                </td>
                            </tr>
                            <tr>
                                <th scope="row" style="width: 10%;">
                                    Description (EN) <!--생성-->
                                </th>
                                <td>
                                    <input v-model="plcy.enDesc" class="lang-input" type="text" placeholder="Description (EN)">
                                </td>
                            </tr>
                            <tr>
                                <th scope="row" style="width: 10%;">
                                    Description (KO)<!--업데이트-->
                                </th>
                                <td>
                                    <input v-model="plcy.koDesc" class="lang-input" type="text" placeholder=" Description (KO)">
                                </td>
                            </tr>
                            <tr>
                                <th scope="row" style="width: 10%;">
                                    Description (ZH)<!--업데이트-->
                                </th>
                                <td>
                                    <input v-model="plcy.zhDesc" class="lang-input" type="text" placeholder="Description (ZH)">
                                </td>
                            </tr>
                            <tr>
                                <th scope="row" style="width: 10%;">
                                    Action
                                </th>
                                <td>
                                    <button type="button" class="buttons-icon" data-type="line" data-size="s" data-icon="confirm" :title="$t('COMMON.BUTTON.CAMEL.OK')" @click="updtPlcy('titl')"><!--확인--></button>
                                    <button type="button" class="buttons-icon" data-type="line" data-size="s" data-icon="refresh" :title="$t('COMMON.BUTTON.CAMEL.CANCEL')" @click="cancelUpdtPlcy('titl')"><!--취소--></button>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                    <!-- 적용된 규칙 -->
                    <SystemRuleList
                        :isReplica="isReplica"
                        :doRefresh="doRefresh"
                        :categoryList="categoryList"
                        :policy="plcy"
                        :cur-rule="detailRuleInfo"
                        :callOpenRuleDetail="openRuleDetail"
                        :callOpenPopup="openPopup"
                        :callDeleteRule="deleteGovernanceRule"
                        :key="getLocale"
                        :ruleList="govRuleListByKey"
                        :callSetSearchKey="setSearchKey"
                        :callSetSortColumn="setSortColumn"
                    />
                </div>
                <side-rule-detail
                    :policy="plcy"
                    v-bind:rule="detailRuleInfo"
                    :categoryList="categoryList"
                    :actionTemplateList="actionTemplateList"
                    :userList="userList"
                    :callHideDetail="closeRuleDetail"
                    :callDeleteRule="deleteGovernanceRule"
                    :callOpenPopup="openPopup"
                />
            </div>
        </article>

        <!-- 팝업 모음 -->
        <rule-popup
            :actionListBySelectedTemplate="actionListBySelectedTemplate"
            :isRenderPopup="isRenderPopup"
            :callLoading="callLoading"
            ref="RulePopup"
            :rule="rule"
            :newTmplt="newTmplt"
            :isEdit="isEdit"
            :isCopy="isCopy"
            :categoryList="categoryList"
            :tmpltList="templateList"
            :actionTemplateList="actionTemplateList"
            :userList="userList"
            :pending="popupSavePending"
            :saveRule="insertGovernanceRule"
            :setActionList="setActionList"
            :rule-popup-key="rulePopupKey">
        </rule-popup>

        <pop-add-cmpl-sche
            ref="popAddCmplSche"
            v-bind:cmpl="plcy"
            v-bind:pending="popupSavePending"
            @fnSaveSchedule="addPolicyToCompliance($event)">
        </pop-add-cmpl-sche>
        <div-loading v-if="pending" :full="true"></div-loading>
    </main>
</template>
<script>

    import SystemRuleList from "./systemRuleList.vue";
    import RulePopup from "./systemRulePopup.vue";
    import PolicySideRuleDetail from "../policy/policySideRuleDetail.vue";
    import {EventBus} from "../common/event-bus";
    import PopAddCmplSche from "../policy/popAddCmplSche.vue";
    import _ from "lodash";
    import {mapGetters} from "vuex";

    export default {
        name: 'systemPolicyDetail',
        components: {
            'pop-add-cmpl-sche': PopAddCmplSche,
            'rule-popup': RulePopup,
            SystemRuleList,
            'side-rule-detail': PolicySideRuleDetail,
        },
        data: function() {
            return {
                message: '메시지',
                isReady: false,
                isEdit: false, // Rule Popup 등록, 수정 상태 체크
                isCopy: false, // Rule Popup 등록, 수정 상태 체크
                doRefresh: false, // rule list refresh 값
                plcy: {},
                originPlcy: {},
                categoryList: [],
                actionTemplateList: [], // Action Template List
                userList: [], // User List for Action
                detailRuleInfo: {},
                rule: {}, // popup 에 보내줄 rule 데이터
                newTmplt: [], //
                invalidPolicyTitle: false, // Policy Title 유효성 검사
                duplicatedPolicyTitle: false, // Policy Title 중복 검사
                invalidPolicyDesc: false, // Policy Desc 유효성 검사
                fEdit:{
                    titl : false,
                    desc : false
                },
                pending: false,
                popupSavePending: false,
                rulePopupKey: 0,
                isRenderPopup: true,
                actionListBySelectedTemplate: [],
                govRuleList: [],
                govRuleListByKey: [],
                policyDetail: {},
                searchSvrty: this.constants.PARAM.SELECT.SEARCH_SEVERITY,                     // SearchList of Severity : 처음 전체선택으로 모든 값 넣어줌
                sortColumn: '',                                // Sort column
                sortOrder: '',                                 // Sort order
                ruleListSearchKey: {},
                rvsnId: this.$route.query.rvsn
            }
        },
        created: function() {
            this.slctPlcy();
            this.selectCategoryList();
            this.selectActionTemplateList();
            this.selectUserList();
            this.selectGovernanceRuleList();
            EventBus.$on("emit-copy-rule", ruleId => {
                this.openCopyRulePopup(ruleId)
            });
        },
        mounted: function() {
            this.setManagementOptions()
        },
        computed: {
            ...mapGetters({
                curCmpnId: 'user/curCmpnId'
            }),
            getMenuAuth: function(){
                //메뉴 별 권한
                let auth = _.find(this.$store.state.GOV_MENU_AUTH, {menuId: this.constants.MENU.POLICY})
                return auth ? auth.authTypeCd : this.constants.AUTH_TYPE.NONE
            },
            templateList: function() {
                return this.$store.state.templateList;
            },
            // url 에 /replica 가 있으면 Policy 복사로 들어온 것
            isReplica: function () {
                return this.$route.path.indexOf('/replica') > -1;
            },
            bUserSetting: function(){
                return this.plcy.userDefiYn === 'Y'
            },
            getLocale: function() {
                return this.$i18n.locale
            }
        },
        watch:  {
            curCmpnId: function() {
                this.$router.push(`/policy`)
            },
            'doRefresh': function () {
                this.slctPlcy();
                this.selectGovernanceRuleList();
            }
        },
        methods: {
            setSortColumn: function (sortColumn) {
                if (this.sortColumn !== sortColumn) {
                    this.sortColumn = sortColumn
                    this.sortOrder = 'asc'
                } else if (this.sortColumn === sortColumn && this.sortOrder === 'asc') {
                    this.sortOrder = 'desc'
                } else if (this.sortColumn === sortColumn && this.sortOrder === 'desc') {
                    this.sortColumn = ''
                    this.sortOrder = ''
                }
                this.getRuleByKey();
            },
            setSearchKey(key, value) {
                this.ruleListSearchKey = {
                    ...this.ruleListSearchKey,
                    [key]: value
                };
                this.getRuleByKey();
            },
            getRuleByKey() {
                const {searchTxt, searchCtg, searchProd} = this.ruleListSearchKey;
                let self = this;
                let filtered =  _.cloneDeep(this.govRuleList);
                filtered = _.forEach(filtered, function (o) {
                    _.forEach(o.cndVal, function(k){
                        let ruleProd = _.find(self.templateList, {'tmpltId': k.tmpltId})
                        if(typeof(ruleProd) !== 'undefined'){
                            o.prodNm = ruleProd.prod
                        }
                    })
                })
                // Text filter
                if (typeof (searchTxt) !== 'undefined' && searchTxt !== '') {
                    filtered = this.govRuleList.filter((item) => {
                        const ruleName = this.rule[this.$i18n.locale + 'RuleTitle'];
                        if (ruleName) {
                            return ruleName.toLowerCase().includes(searchTxt.toLowerCase());
                        } else {
                            return item.titl.toLowerCase().includes(searchTxt.toLowerCase());
                        }
                    })
                }
                // Category filter
                if (typeof(searchCtg) !== 'undefined' && searchCtg.length > 0) {
                    filtered = _.filter(filtered, function (o) {
                        for(let srchCtg of searchCtg){
                            if(_.includes(o.ctgLabel, srchCtg)) {
                                return true
                            }
                        }
                        return false
                    })
                }
                // Product filter
                if (typeof(searchProd) !== 'undefined' && searchProd.length > 0) {
                    filtered = _.filter(filtered, function (o) {
                        let fill = _.filter(o.cndVal, function(k){
                            let ruleProd = _.find(self.templateList, {'tmpltId': k.tmpltId})
                            for(let srchProd of searchProd){
                                if(ruleProd.prod === srchProd){
                                    return true
                                }
                            }
                            return false
                        })
                        return fill.length > 0
                    })
                }
                if(!(this.searchSvrty.length === this.constants.SVRTY_FILTER.length)){
                    filtered = filtered.filter((p) => {
                        return _.includes(this.searchSvrty, p.svrty)
                    })
                }
                // Sorting 처리
                if (this.sortColumn !== '' && this.sortOrder !== '') {
                    filtered = _.orderBy(filtered, [this.sortColumn], [self.sortOrder])
                }
                this.govRuleListByKey = filtered;
            },
            removeRule(ruleList) {
                // TODO :: Rule List 에서 rule 삭제
                let self = this;
                _.forEach(ruleList, function (rule) {
                    self.govRuleList.splice(_.findIndex(self.ruleList, rule), 1)
                })
                this.govRuleListByKey = self.govRuleList;
            },
            getRuleListOnlyReplica() {
                var list = _.cloneDeep(this.govRuleList)
                for(var rule of list) {
                    rule.titl = rule.transTitl;
                    rule.desc = rule.transDesc;
                    rule.remd = rule.transRemd;
                    rule.cmpnId = this.curCmpnId;
                    rule.cndVal = JSON.stringify(rule.cndVal)
                    rule.actnVal = JSON.stringify(rule.actnVal)
                    rule.ctgLabel = JSON.stringify(rule.ctgLabel)
                }
                return list
            },
            selectGovernanceRuleList() {
                const url = `/api/governance/rule/list`
                let ruleData = {
                    'cmpnId': this.curCmpnId,
                    'rvsnId': this.rvsnId
                }
                this.http.post(url, ruleData)
                    .then((result) => {
                        if(result.data.status === 'ok') {
                            // for 에서 text 를 json 으로 parse
                            for(let rule of result.data.result) {
                                rule.transTitl = rule.userDefiYn === this.constants.PARAM.SELECT.N ? this.rule[this.$i18n.locale+'RuleTitle'] : rule.titl;
                                rule.transDesc = rule.userDefiYn === this.constants.PARAM.SELECT.N ? this.rule[this.$i18n.locale+'RuleDesc'] : rule.desc;
                                rule.transRemd = rule.userDefiYn === this.constants.PARAM.SELECT.N ? this.rule[this.$i18n.locale+'RuleRemd'] : rule.remd;
                                rule.cndVal = JSON.parse(rule.cndVal)
                                rule.actnVal = JSON.parse(rule.actnVal)
                                rule.ctgLabel = JSON.parse(rule.ctgLabel)
                            }
                            this.govRuleList = result.data.result;
                            this.getRuleByKey();
                        }
                    })
            },
            callLoading(isLoading) {
                this.pending = isLoading;
            },
            slctPlcy: function () {
                this.callLoading(true);
                var url = `/api/governance/policy/policy`;
                var header = {
                    'cmpnId': this.curCmpnId,
                    'rvsnId': this.rvsnId
                };
                this.http.post(url, JSON.stringify(header))
                    .then(result => {
                        this.plcy = result.data.result;
                        // this.plcy.desc = this.isReplica ? this.plcy[this.$i18n.locale+'Desc'] : this.plcy.desc;
                        // this.plcy.transTitl = this.plcy.userDefiYn === this.constants.PARAM.SELECT.N ? this.plcy[this.$i18n.locale+'Title'] : this.plcy.titl;
                        // this.plcy.titl = this.isReplica ? this.plcy.transTitl : this.plcy.titl;
                        this.originPlcy = _.cloneDeep(this.plcy);
                        this.$nextTick(function () {
                            this.initView();
                        });
                        this.callLoading(false);
                    });
            },
            // Policy Title, Description 수정
            updtPlcy(item) {
                // if(this.isInvalidPolicyTitle()) return;
                let plcyData = {
                    'cmpnId': this.curCmpnId,
                    'plcyId': this.plcy.plcyId,
                    'rvsnId': this.rvsnId,
                    'enTitle': this.plcy.enTitle,
                    'koTitle': this.plcy.koTitle,
                    'zhTitle': this.plcy.zhTitle,
                    'enDesc': this.plcy.enDesc,
                    'koDesc': this.plcy.koDesc,
                    'zhDesc': this.plcy.zhDesc
                };
                var url = `/api/governance/policy/system`;

                this.http.put(url, plcyData)
                    .then((result) => {
                        if (result.data.status === 'ok') {
                            // this.plcy = result.data.result;
                            this.changeEditStatus(item, false)
                            this.originPlcy = _.cloneDeep(this.plcy);
                            this.rvsnId = result.data.result.rvsnId;
                            this.$router.replace(`/policy/mng/system/${this.rvsnId}`);
                        } else if(result.data.status === 'fail' && result.data.error.message === 'ERROR_D'){
                            // 타이틀 중복 처리
                            this.duplicatedPolicyTitle = true
                        }
                    }).catch(error => {
                    // TODO :: Error 처리
                });
            },
            cancelUpdtPlcy(item) {
                this.changeEditStatus(item, false);
                this.plcy = _.cloneDeep(this.originPlcy);
            },
            // Category 목록 조회. Popup, Detail 둘 다 사용하기때문에 여기서 조회
            selectCategoryList() {
                var url = `/api/governance/category/list/simple`;
                var body = {
                    "cmpnId": this.curCmpnId
                };

                this.http.post(url, body)
                    .then(response => {
                        this.categoryList = response.data.result;
                    });
            },
            // Action 목록 조회
            selectActionTemplateList() {
                // Action List 초기화
                this.actionTemplateList = [];

                const url = `/api/governance/actn`;
                this.http.get(url)
                    .then(response => {
                        this.actionTemplateList = response.data.result;
                    });
            },
            // Action Email 에서 사용할 사용자 List 가져오기
            selectUserList() {
                const url = `/api/governance/user/list`;
                const header = {
                    'cmpnId': this.$store.state.loginUser.curCmpnId
                };

                this.http.post(url, header)
                    .then(response => {
                        if (response.data.status === 'ok') {
                            this.userList = response.data.result;
                        }
                    });
            },
            policyPopupOpen: function () {
                // Policy 등록 버튼 클릭 시
                alert('The Policy Popup Button Clicked' + this.curCmpnId);
            },
            convertUtcTimezoneToLocal: function(date) {
                return date == null ? '-' : this.Common.convertUtcTimezoneToLocalByLang(date, this.getLocale)
            },
            initView: function () {
                // Rule Popup
                $('[data-trigger="add-rule"]').magnificPopup({
                    items: {
                        src: '#popup-add-governance-rule'
                    }
                });
            },
            rerenderPopup() {
                // Remove component from the DOM
                this.isRenderPopup = false;
                this.$nextTick(() => {
                    // Add the component back in
                    this.isRenderPopup = true;
                });
            },
            setActionList(selectedTemplateList) {
                let actionListBySelectedTemplate = (_.filter(this.actionTemplateList, {'prod': 'default'}));
                _.forEach(_.groupBy(selectedTemplateList, 'prod'), function(value, key) {
                    actionListBySelectedTemplate = actionListBySelectedTemplate.concat(_.filter(self.actionTemplateList, {'prod': key}));
                });
            },
            openPopup: function (rule, FORM_TYPE) {
                this.rerenderPopup();
                this.isEdit = false;
                this.isCopy = false;
                if (FORM_TYPE === this.constants.FORM_TYPE.EDIT) {
                    this.isEdit = true;
                } else if (FORM_TYPE === this.constants.FORM_TYPE.COPY) {
                    this.isCopy = true;
                }
                this.rulePopupKey += 1

                $('[data-trigger="add-rule"]').trigger('click');

                this.newTmplt = [];
                if (rule != null) {
                    this.rule = _.cloneDeep(rule);
                    // 다국어 정의되고 바꾼다...
                    this.rule.titl = this.isCopy ? this.$t('POLICY.RULE.COPY_TITLE', {'ruleName': this.rule.titl}) : this.rule.titl
                    // TODO :: 이거 여기서 할 필요가 있을까? rulePopup 쪽에서 하면 좋을 것 같음. 근데 어떻게 해야하지
                    // 선택한 Rule 정보에서 화면에 그려줄 Template 정보 newTmplt 에 넣어주기
                    for (var cnd of this.rule.cndVal) {
                        // newTemplate 에 맞는 Template ID 넣어주기
                        for (var tmplt of this.templateList) {
                            if (cnd.tmpltId === tmplt.tmpltId) {
                                this.newTmplt.push(tmplt);
                            }
                        }
                    }
                } else {
                    this.rule = this.getDefaultRuleObject();
                }
                // 수정의 경우 먼저 선택한 Action List 세팅
                this.setActionList(this.newTmplt);
            },
            // Open side rule view
            openRuleDetail: function (rule) {
                this.detailRuleInfo = rule
                typeof($('.layout-contents').attr('data-side-expand')) === 'undefined' ? $('.layout-contents').toggleAttr('data-side-expand', '') : false
            },
            // Close side rule view
            closeRuleDetail: function () {
                this.detailRuleInfo = {}
                $('.layout-contents').removeAttr('data-side-expand')
            },

            editRule(rule) {
                const idx = _.findIndex(this.ruleList, function(o) {
                    return o.ruleId === rule.ruleId
                });
                this.ruleList[idx] = rule;
            },
            addRule(rule) {
                this.govRuleList.push(rule);
                this.govRuleListByKey = this.govRuleList;
            },
            // isEdit 로 구분해서 Insert, Update 함
            insertGovernanceRule(rule) {
                this.popupSavePending = true
                // Policy 복제일 때
                if(this.isReplica) {
                    this.Common.closePopup()
                    if(this.isEdit) {
                        this.editRule(rule)
                        // case1. policy 복사에서 룰 수정
                        EventBus.$emit('toastComment', 'POLICY.TOAST.EDITED_RULE')
                    } else {
                        rule.ruleId = this.Common.uuid()
                        this.addRule(rule);
                        if(typeof(this.isEdit) === 'undefined'){
                            // case2. policy 복사에서 룰 복사
                            EventBus.$emit('toastComment', 'POLICY.TOAST.COPIED_RULE')
                        }else{
                            // case3. policy 복사에서 룰 추가
                            EventBus.$emit('toastComment', 'POLICY.TOAST.ADDED_RULE')
                        }

                    }
                    this.popupSavePending = false
                    this.callLoading(false);
                } else {
                    rule.titl = rule[this.$i18n.locale+"RuleTitle"];
                    // string 으로 변경하기 전 newObj 복사. 화면에서 string 으로 바꼈다고 에러 폭발함
                    let tempObj = _.cloneDeep(rule)

                    tempObj.cmpnId = this.curCmpnId
                    tempObj.plcyId = this.plcy.plcyId
                    tempObj.plcyRvsnId = this.rvsnId

                    tempObj.cndVal = JSON.stringify(tempObj.cndVal)
                    tempObj.actnVal = JSON.stringify(tempObj.actnVal)
                    tempObj.ctgLabel = JSON.stringify(tempObj.ctgLabel)

                    var url = `/api/governance/rule/system`;
                    var header = tempObj;

                    if (this.isEdit) {
                        this.http.put(url, header)
                            .then(response => {
                                this.afterSaveRule(response.data.result.plcyRvsnId)
                                this.popupSavePending = false

                                // 기본 policy에서 rule 수정
                                EventBus.$emit('toastComment', 'POLICY.TOAST.EDITED_RULE')
                            })
                            .catch(err => {
                                this.popupSavePending = false
                            })
                    } else {
                        url = `/api/governance/rule/system`
                        header = tempObj
                        this.http.post(url, JSON.stringify(header))
                            .then(response => {
                                this.afterSaveRule(response.data.result.plcyRvsnId)
                                this.Common.closePopup()
                                this.popupSavePending = false
                                if(typeof(this.isEdit) === 'undefined'){
                                    // case4. 기본 policy에서 rule 복사
                                    EventBus.$emit('toastComment', 'POLICY.TOAST.COPIED_RULE')
                                }else{
                                    // case5. 기본 policy에서 rule 추가
                                    EventBus.$emit('toastComment', 'POLICY.TOAST.ADDED_RULE')
                                }
                            })
                            .catch(err => {
                                this.popupSavePending = false
                            })
                    }
                }
            },
            deleteGovernanceRule(delRuleList) {
                let self = this;
                this.Common.setConfirmBtnCustom(this.$t('POLICY.RULE.POPUP.TITLE.DELETE'), this.$t('POLICY.RULE.POPUP.DESC.DELETE'),this.$t('COMMON.BUTTON.CAMEL.CANCEL'), this.$t('COMMON.BUTTON.CAMEL.OK'), function(confirm) {
                    if(confirm) {
                        if(!self.isReplica){ // 복제 상태가 아닌경우 바로 delete
                            const url = `/api/governance/rule/delete/system`;
                            let cloneRuleList = _.cloneDeep(delRuleList)
                            // 표시 위해 List로 바꾼걸 다시 String으로 바꿈. 삭제 시 API 쪽에서 Type Error 발생함(공통 로직 사용으로 여기서 변경해서 보내줌..)
                            for(let rule of cloneRuleList) {
                                rule.cndVal = JSON.stringify(rule.cndVal)
                                rule.actnVal = JSON.stringify(rule.actnVal)
                                rule.ctgLabel = JSON.stringify(rule.ctgLabel)
                            }
                            let ruleData = {
                                'cmpnId': self.$store.state.loginUser.curCmpnId,
                                'plcyId': self.plcy.plcyId,
                                'plcyRvsnId': self.rvsnId,
                                'ruleList': cloneRuleList
                            };
                            self.http.post(url, ruleData)
                                .then((response) => {
                                    // eunhye check
                                    EventBus.$emit('toastComment', 'POLICY.TOAST.DELETED_RULE');

                                    if (response.data.status === 'ok') {
                                        self.closeRuleDetail();
                                        self.afterSaveRule(self.rvsnId);
                                    } else {
                                        // TODO :: Error 처리
                                    }
                                }).catch(error => {
                                // TODO :: Error 처리
                            });
                        }else{
                            self.removeRule(delRuleList);
                            EventBus.$emit('toastComment', 'POLICY.TOAST.DELETED_RULE');
                        }
                    }
                });
            },
            // Rule 기본되는 값
            getDefaultRuleObject() {
                return {
                    titl: '',
                    actnExeYn: 'Y',
                    ctgLabel: [],
                    cndVal: [{
                        tmpltId: 'new',
                        cjt: null
                    }],
                    svrty: 1,
                    actnVal: [{
                        actnId: null
                    }],
                };
            },
            goBack() {
                this.$router.go(-1)
            },
            replicatePolicy() {
                this.$router.replace(`/policy/${this.rvsnId}/replica`)
            },
            deletePolicy() {
                let self = this;
                this.Common.setConfirmBtnCustom(
                    this.$t('POLICY.LABEL.DEL_POLICY'),
                    self.plcy.cmplStat === 'R' ? this.$t('POLICY.DEL_POPUP.DESC_BEING_EVALUATED') : self.plcy.cmplId !== null ? this.$t('POLICY.DEL_POPUP.DESC_INCLUDED_COMPLIANCE') : this.$t('POLICY.DEL_POPUP.DESC'),
                    this.$t('COMMON.BUTTON.CAMEL.CANCEL'),
                    this.$t('COMMON.BUTTON.CAMEL.OK'), (result)=>{
                        if(result){
                            let header = {
                                'cmpnId': self.plcy.cmpnId,
                                'plcyId': self.plcy.plcyId,
                                'rvsnId': self.plcy.rvsnId
                            };

                            let url = `/api/governance/policy/delete`
                            self.http.post(url, JSON.stringify(header))
                                .then(response => {
                                    this.$router.push('/policy')
                                })

                        }
                    })
            },
            goToHistory(plcy){
                const url = '/audit/detail';
                this.$router.push({path: url, query: {plcy: plcy.plcyId}});
            },
            afterSaveRule(newPlcyRvsnId) {
                // newPlcyRvsnId : 새 Policy Revision ID
                $.magnificPopup.close()
                this.doRefresh = !this.doRefresh

                this.$router.replace(`/policy/mng/system/${newPlcyRvsnId}`)
            },
            openCopyRulePopup: function (ruleId) {
                this.openPopup(data)
            },
            // Replica Policy 등록
            insertReplicaPolicy() {
                this.callLoading(true);
                // Policy Title 에 대한 유효성 검사
                if(this.isInvalidPolicyTitle()) return

                // 복사본이며 동시에 사용자 정의 폴리시이다. 현재 회사 ID로 폴리시를 등록해야 함.
                this.plcy.rplcYn = 'Y'
                this.plcy.userDefiYn = 'Y'
                this.plcy.cmpnId = this.curCmpnId

                var data = {
                    plcy : this.plcy,
                    rule : this.getRuleListOnlyReplica()
                };

                var url = `/api/governance/policy/replica`
                this.http.post(url, JSON.stringify(data))
                    .then(response => {
                        if(response.data.status === 'ok') {
                            this.$router.push('/policy')
                            EventBus.$emit('toastComment', 'POLICY.TOAST.COPIED_POLICY')
                        }
                        else if(response.data.status === 'fail' && response.data.error.message === 'DUPLICATE POLICY TITLE'){
                            // 타이틀 중복 처리
                            this.duplicatedPolicyTitle = true
                        }
                        this.callLoading(false);
                    });

            },

            // 유효성 검사
            isInvalidPolicyTitle() {
                this.duplicatedPolicyTitle = false
                this.invalidPolicyTitle = !!this.Common.isEmptyText(this.plcy.titl);
                return this.invalidPolicyTitle
            },
            openAddPopup: function (plcy, popupId) {
                //  TODO :: Compliance 입력할 정보 넣어줘야함
                this.Common.viewPopup(popupId)
            },
            setManagementOptions: function() {
                var $moreActions = $('[data-trigger="management"]')
                $moreActions.tooltipster({
                    animation: 'fade',
                    side: 'bottom',
                    theme: 'go-actions',
                    interactive: true,
                    trigger: 'click',
                    arrow: false,
                    functionBefore: function(instance, helper) {
                        $(helper.origin).addClass("selected")
                    },
                    functionAfter: function(instance, helper) {
                        $(helper.origin).removeClass("selected")
                    },
                    functionPosition: function(instance, helper, position) {
                        position.coord.top -= 7
                        position.coord.left = helper.geo.origin.offset.right - position.size.width
                        return position;
                    }
                });
            },
            changeEditStatus(item, status){
                this.fEdit[item] = status
            }

        }
    }
</script>

<style scoped>
    .layout-contents-container .layout-contents[data-side-expand] .left-view{
        width: 100%;
    }
    .layout-contents-container .layout-contents[data-side-expand] .right-view {
        position: absolute;
        right: 0;
        box-shadow: -5px 16px 8px #888888;
        width: 80%;
        height: 98%;
        max-height: 98%;
        max-width: 80%;
        z-index: 10;
    }
    .lang-input{
        min-width: 100%;
    }.layout-popup[data-layout-step]{
         max-height: 100%;
     }
</style>



// WEBPACK FOOTER //
// src/components/bestpractice/systempolicyDetail.vue